import styled from "styled-components";

export const HeaderWrapper = styled.div`
  background: #1bace4;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
  font-weight: bold;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  overflow-y: auto;
`;

export const MapContainer = styled.div`
  border-radius: 4px;
  position: relative;
  height: 300px;
  overflow: hidden;
  outline: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  margin: 0 1.375rem;
`;

export const LineBreak = styled.div`
  border: 1px solid #004c7f;
  margin: 0 91px 0 91px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;
